<template>
  <div class="about-us">
    <AboutIntro />
    <AboutInfo />
    <AboutFooter />
    <AboutSubmit />
  </div>
</template>

<script setup>
import AboutIntro from "./AboutIntro.vue";
import AboutInfo from "./AboutInfo.vue";
import AboutFooter from "./AboutFooter.vue";
import AboutSubmit from "./AboutSubmit.vue";

// Fix viewport height layout shifts on iPhone 16+
useStableViewport();
</script>
<style lang="scss" scoped>
.about-us {
  font-family: "Book21", "Sharp Grotesk", sans-serif;
  $t_c: white;
  background-color: #000;
  // padding: 2em;
  padding-top: 6em;
  font-size: 16px;
}
</style>
